exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1L0ogvcFqIsl0kBA4jYH4T{max-width:800px!important;max-height:700px!important}._2TRHKFxH5c377cFhmj3SDe{display:inline-block}._1JuQNsjIEN2p54S8UtQJDR{width:600px}._2KtnemqgWZkB39u3s6MPDf{width:400px}._3uLOI7oiGAvTQwtn-IbUJS{color:#e81123;display:inline-block;width:400px;font-size:14px;font-weight:400}", ""]);

// exports
exports.locals = {
	"dialog": "_1L0ogvcFqIsl0kBA4jYH4T",
	"spinner": "_2TRHKFxH5c377cFhmj3SDe",
	"options": "_1JuQNsjIEN2p54S8UtQJDR",
	"textbox": "_2KtnemqgWZkB39u3s6MPDf",
	"error": "_3uLOI7oiGAvTQwtn-IbUJS"
};